export const APPROVAL_TYPES = ["SINGLE", "PARALLEL"];
export const APPROVAL_ROLES = [
  "BUSINESS_FINANCE",
  "BUSINESS_ACCOUNTS",
  "LEGAL",
  "ADMIN",
  "USER"
];

export const populateStage = (stages, activeStep) => {
  return stages.map((element) => {
    if (element.stageName === activeStep.stageName) {
      return {
        stageName: activeStep.stageName,
        approvalType: activeStep.approvalType,
        approverRoles: activeStep.approverRoles,
        docUpload: activeStep.docUpload
      };
    }

    return {
      stageName: element.stageName,
      approvalType: element.approvalType,
      approverRoles: element.approverRoles,
      docUpload: element.docUpload
    };
  });
};